import { EntityListContentStructure } from './EntityListContentStructure';
import { EntityListContentItem } from '../entityListTypes';

export class ProductEntityListContentStructure implements EntityListContentStructure {
  getContentTableStructure(): EntityListContentItem[] {
    return [EntityListContentItem.PRODUCT];
  }

  getContentObjectPath(contentItem: EntityListContentItem): string[] {
    if (contentItem === EntityListContentItem.PRODUCT) {
      return ['product'];
    } else {
      throw new Error(`Unknown content item: ${contentItem}`);
    }
  }
}
